<template>
  <div>
    <!-- 头部 -->
    <el-row>
      <el-form
        :inline="true"
        class="demo-form-inline toolbar"
        style="padding-bottom: 0px"
      >
        <el-form-item
          label="老人姓名"
          style="margin-left: 30px"
          prop="typeName"
        >
          <el-input
            v-model.trim="oldName"
            placeholder="请输入老人姓名"
            clearable
            @keyup.enter.native.prevent="getDataList"
          ></el-input>
        </el-form-item>
        <el-form-item
          label="老人身份证"
          style="margin-left: 30px"
          prop="typeName"
        >
          <el-input
            v-model.trim="idCard"
            placeholder="请输入老人身份证"
            clearable
            @keyup.enter.native.prevent="getDataList"
          ></el-input>
        </el-form-item>
        <el-form-item>
          <el-button
            type="primary"
            icon="el-icon-search"
            plain
            style="margin-left: 20px"
            @click="getDataList"
          >
            查询</el-button
          >
          <el-button type="warning" icon="el-icon-plus" @click="headAdd" plain>
            新增</el-button
          >
        </el-form-item>
      </el-form>
    </el-row>

    <!-- table -->
    <div v-loading="loading" element-loading-text="拼命加载中......">
      <el-table
        :data="list"
        style="width: 100%;margin-top:-10px"
      :row-style="tableRowStyle"
              :header-cell-style="tableHeaderColor"
              :cell-style="{ 'text-align': 'center', 'font-size': '16px' }"
      >
        <el-table-column
          prop="oldmanName"
          label="老人姓名"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="idCard"
          label="身份证号"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="date"
          label="调整日期"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="total"
          label="补缴合计"
          align="center"
          width="140"
        ></el-table-column>
        <el-table-column
          prop="reason"
          label="调整原因"
          align="center"
          :formatter="formatReason"
        ></el-table-column>
        <el-table-column
          prop="state"
          label="状态"
          align="center"
          :formatter="formatState"
        ></el-table-column>
        <el-table-column label="操作" align="center">
          <template slot-scope="scope">
            <el-button
               style="margin-right: 5px"
              type="success"
              size="mini"
              plain
              @click="handleShow(scope.$index, scope.row)"
              >查看</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        background
        @current-change="handleCurrentChange"
        :current-page="pageNum"
        layout="total, prev, pager, next"
        :total="totalSize"
        :page-size="pageSize"
        align="center"
        class="fenye"
      ></el-pagination>
    </div>
  </div>
</template>
<script>
// 调房调级
import bus from "@/vuex/eventBus";
export default {
  name: "Form",
  data() {
    return {
      loading: false,
      list: [],
      pageNum: 1,
      totalSize: 0,
      pageSize: 10,
      oldName: "",
      idCard: "",
    };
  },
  methods: {
    formatReason(row, column) {
      if (row.reason == 1) {
        return "身体条件变差";
      } else if (row.reason == 2) {
        return "老人不适应";
      } else if (row.reason == 3) {
        return "主动调整";
      }
    },
    formatState(row, column) {
      if (row.state == 1) {
        return "未提交";
      } else if (row.state == 2) {
        return "申请中";
      } else if (row.state == 3) {
        return "待审批";
      } else if (row.state == 4) {
        return "不通过";
      } else if (row.state == 5) {
        return "待审批";
      } else if (row.state == 6) {
        return "已确认";
      }
    },
    tableRowStyle({ row, rowIndex }) {
      if (rowIndex % 2 == 0) {
        return "background-color: #ffffff";
      } else {
        return "background-color: #e4f5f8";
      }
    },

    /* 
            修改table header的背景色
        */
    tableHeaderColor({ row, column, rowIndex, columnIndex }) {
      if (rowIndex === 0) {
        return "color:#2d2d2d;font-weight: 600; text-align: center;font-size: 16px;background-color: #d4f5fa;";
      }
    },
    //分页控件,
    handleCurrentChange(val) {
      this.pageNum = val;
      this.getDataList();
    },
    //获取数据列表
    getDataList() {
      var info = {
        pageNum: this.pageNum,
        pageSize: this.pageSize,
        oldmanName: this.oldName,
        idCard: this.idCard,
      };
      this.$post("fmc/revise/queryListWithPage", info, "", "json").then(
        (res) => {
          this.list = res.list;
          this.totalSize = Number(res.total);
        }
      );
    },
    headAdd() {
          bus.$emit("homePage", {
            type: "jump",
            path: "/changeFeeAdd",
            title: "调房调级申请",
          });
      // this.$post("omc/revise/queryOldmanList").then(
      //   (res) => {
          
      //   },
      //   (err) => {
      //     this.$message({ type: "error", message: err.message });
      //   }
      // );
    },
    handleShow(index, row) {
      bus.$emit("homePage", {
        type: "jump",
        path: "/changeFeeShow",
        title: "调房调级查看",
      });
      setTimeout(function () {
        if (row != null && row.id != null) {
          bus.$emit("tftjId", row.id + "," + 1);
        }
      }, 100);
    },
  },
  mounted() {
    this.getDataList();
  },
  computed: {},
};
</script>
<style scoped>
.header_padding {
  margin-bottom: 5px;
}
.fenye {
  padding: 30px 0;background: #fff;
}
</style>
